import React, { Component } from "react";
import PreviewTermsConditions from "../../../shared/previewTermsConditions/PreviewTermsConditions";
import styles from "./AcceptTermsAndConditions.module.scss";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import { TERMS_AND_CONDITIONS } from "../../../common/Constants";
import PendingActionPrompt from "../../../shared/pendingActionPrompt/PendingActionPrompt";
import ConfirmDialog from "../../../shared/confirmDialog/ConfirmDialog";
import { withTranslation } from "react-i18next";
import HasPermissionTo from "../../../common/HasPermissionTo";
import TermsAndConditionsClient from "../../../shared/clients/TermsAndConditionsClient";
import PendingActionClient from "../../../shared/clients/PendingActionClient";

class AcceptTermsAndConditions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openDeclinePAPrompt: false,
      openConfirmPAPrompt: false,
      openDeclineDialog: false,
      openConfirmDialog: false,
      dealersActioned: [],
      dealersNotActioned: [],
    };
    this.customText = {
      actioned: this.props.t("PendingActionPrompt.actioned"),
      notActioned: this.props.t("PendingActionPrompt.notActioned"),
      applySelective: this.props.t("PendingActionPrompt.applySelectiveTerms"),
    };
    this.deactivateDialogProps = {
      title: this.props.t("BusinessSettings.titleDecline"),
      bodyText: this.props.user.isLoggedInUserMDLR
        ? this.props.t("BusinessSettings.bodyTextDeclineWarning")
        : this.props.t("BusinessSettings.bodyTextDecline"),
      confirm: this.props.t("BusinessSettings.confirm"),
      cancel: this.props.t("BusinessSettings.cancel"),
    };
    this.confirmDialogProps = {
      title: this.props.t("BusinessSettings.titleAccept"),
      bodyText: this.props.t("BusinessSettings.bodyTextAcceptWarning"),
      confirm: this.props.t("BusinessSettings.confirm"),
      cancel: this.props.t("BusinessSettings.cancel"),
    };
    this.dealerList = this.getDealerGroupNonSdlr();
    this.tnCStatus = {};
    this.onboardedDealerGroup = this.props.user.getOnboardedDealerGroup(true);
    this.termsAndConditions = this.props.termsAndConditions;

    if (!this.termsAndConditions) {
      if (
        this.props.location &&
        this.props.location.query &&
        this.props.location.query.fromPendingActions
      ) {
        this.termsAndConditions = this.props.termsAndConditionsHistory.find(
          (termsAndConditionsHistory) =>
            termsAndConditionsHistory.futureTermsConditions ===
            this.props.history.location.query.isFutureTermsAndConditions
        );
        this.termsAndConditions["actionId"] =
          this.props.history.location.query.actionId;
      } else {
        this.termsAndConditions = this.props.termsAndConditionsHistory[0];
      }
    }
  }

  componentDidMount() {
    this.tnCStatus = this.getTnCActionStatus();
  }

  handleDeclinePAClose = () => {
    this.setState({ openDeclinePAPrompt: false });
  };

  handleConfirmPAClose = () => {
    this.setState({ openConfirmPAPrompt: false });
  };

  handleDeclineClose = () => {
    this.setState({ openDeclineDialog: false });
  };

  handleConfirmClose = () => {
    this.setState({ openConfirmDialog: false });
  };

  handleConfirmation = (
    termsAndConditions,
    acceptance,
    commonIds,
    dealerIds
  ) => {
    this.props.hideOrShow(true);
    TermsAndConditionsClient.saveDealerTermsAndConditionsAcceptance(
      this.props.user,
      termsAndConditions,
      acceptance,
      commonIds.toString().split("|").join("%7C")
    )
      .then(() => {
        if (acceptance) {
          PendingActionClient.removeDealerPendingAction(
            this.props.user,
            dealerIds,
            TERMS_AND_CONDITIONS,
            null,
            null,
            termsAndConditions.actionId
          ).then(() => {
            this.props.getPendingActions().then(() => {
              this.props.alterComponentView(termsAndConditions);
            });
          });
        } else {
          this.props.alterComponentView(termsAndConditions);
        }
      })
      .catch(() => {})
      .finally(() => {
        if (this.props.user.dealerGroupingsMap) {
          this.props.user.updateUnOnboardedDealers(
            this.props.user.getDealerList(),
            TERMS_AND_CONDITIONS
          );
          this.props.user.updateToggleDisabled(
            this.props.user.getDealerList(),
            TERMS_AND_CONDITIONS
          );
        }
        this.props.hideOrShow(false);
      });
  };

  getCondition = () => {
    const isMainViewingSDLR = this.props.isMainViewingSDLR(this.props.user);

    if (isMainViewingSDLR) return false;

    // Returns true if the current view is the All CMAs view
    const isMainViewingAll = () => {
      return this.props.user.isLoggedInUserMDLR && this.props.user.showAll;
    };

    // Returns true if all of the remaining pending actions are for SDLR dealers
    const doesPAOnlyForSDLR = () => {
      const pendingAction = this.props.user.pendingActions.filter(
        (pendingAction) => pendingAction.actionName === TERMS_AND_CONDITIONS
      )[0];
      if (!pendingAction) return false;
      let allRemainingSDLR = true;
      const dealerIdList = pendingAction.attributes.dealerIds;
      dealerIdList.forEach((dealerId) => {
        if (
          this.props.user.dealerGroupingsMapByDealerId[dealerId].dealerType !==
          "SDLR"
        ) {
          allRemainingSDLR = false;
        }
      });
      return allRemainingSDLR;
    };

    // If the view is All CMAs and every pending action belongs to SDLR, the main cannot take an action for any of them
    // Therefore, the link should not show

    return !(isMainViewingAll() && doesPAOnlyForSDLR());
  };

  getDealerGroupNonSdlr() {
    const commonIds = this.props.user.getCommonIdsWithoutSDLR().split(",");
    commonIds.forEach((commonId, index) => {
      commonIds[index] = this.props.user.reformatCommonId(commonId);
    });
    return this.props.user.dealerGroup.filter((d) =>
      commonIds.includes(d.commonId)
    );
  }

  getTnCActionStatus = () => {
    const tnCStatus = {};
    const dealersActioned = [];
    const dealersNotActioned = [];
    this.dealerList.forEach((dealer) => {
      dealer.dealerName = dealer.name;
      if (
        this.props.termsAndConditionsHistory[0].acceptedDealers.includes(
          dealer.commonId
        )
      ) {
        dealer.termsStatus = this.props.t("PendingActionPrompt.accepted");
        dealersActioned.push(dealer);
        tnCStatus[dealer.commonId] = this.props.t("ConfirmDialog.accepted");
      } else if (
        this.props.termsAndConditionsHistory[0].declinedDealers.includes(
          dealer.commonId
        )
      ) {
        dealer.termsStatus = this.props.t("PendingActionPrompt.declined");
        dealersActioned.push(dealer);
        tnCStatus[dealer.commonId] = this.props.t("ConfirmDialog.rejected");
      } else {
        dealersNotActioned.push(dealer);
      }
    });

    this.setState({
      dealersActioned: dealersActioned,
      dealersNotActioned: dealersNotActioned,
    });
    return tnCStatus;
  };

  isMainViewingAll() {
    return (
      this.props.user.isLoggedInUserMDLR &&
      this.onboardedDealerGroup.length > 1 &&
      this.props.user.showAll
    );
  }

  isMainViewingBranch() {
    return (
      this.props.user.isLoggedInUserMDLR &&
      this.onboardedDealerGroup.length > 1 &&
      !this.props.user.showAll
    );
  }

  openDialog = (acceptance) => {
    if (this.isMainViewingAll()) {
      acceptance
        ? this.setState({ openConfirmPAPrompt: true })
        : this.setState({ openDeclinePAPrompt: true });
    } else if (this.isMainViewingBranch()) {
      acceptance
        ? this.setState({ openConfirmDialog: true })
        : this.setState({ openDeclineDialog: true });
    } else {
      acceptance
        ? this.handleConfirmation(
            this.termsAndConditions,
            true,
            this.props.user.getCommonIdsWithoutSDLR(),
            this.props.user.getDealerIdsWithoutSDLR()
          )
        : this.setState({ openDeclineDialog: true });
    }
  };

  applyAll = (termsAndConditions, acceptance) => {
    const commonIds = [];
    const dealerIds = [];
    this.dealerList.forEach((dealer) => {
      commonIds.push(dealer.commonId);
      dealerIds.push(dealer.completeDealerId);
    });
    this.handleConfirmation(
      termsAndConditions,
      acceptance,
      commonIds,
      dealerIds
    );
  };

  applySelective = (termsAndConditions, acceptance) => {
    const commonIds = [];
    const dealerIds = [];
    this.dealerList.forEach((dealer) => {
      if (!this.state.dealersActioned.includes(dealer)) {
        commonIds.push(dealer.commonId);
        dealerIds.push(dealer.completeDealerId);
      }
    });
    this.handleConfirmation(
      termsAndConditions,
      acceptance,
      commonIds,
      dealerIds
    );
  };

  render() {
    return (
      <div>
        <div className="pagePadding">
          <Button
            style={{ backgroundColor: "transparent" }}
            onClick={() =>
              this.props.alterComponentView(this.termsAndConditions)
            }
          >
            <div className={styles.backButton}>
              <div className={styles.arrowLeft}>&nbsp;</div>
              <div>
                {this.props.fromPending
                  ? this.props.t("BusinessSettings.backToDashboard")
                  : this.props.t("BusinessSettings.backToEmp")}
              </div>
            </div>
          </Button>
          <div className={styles.termsConditionsHeader}>
            {this.props.t("BusinessSettings.termsTitle")}
          </div>
          <div className={styles.previewPDFWrapper}>
            <div className={styles.previewPDFTitle}>
              {this.props.user.market.toUpperCase() +
                " " +
                this.props.t("BusinessSettings.termsHeader") +
                this.termsAndConditions.version +
                ".0"}
            </div>
            <div className={styles.effectiveFrom}>
              {" "}
              {this.props.t("BusinessSettings.termsEffectiveDate")}{" "}
              {this.termsAndConditions.effectiveDate})
            </div>
            <PreviewTermsConditions
              className={styles.previewPDF}
              pdfStyling={styles.pdfStyling}
              file={this.termsAndConditions.file}
            />
          </div>
          <div className={styles.downloadNewVersion}>
            <span
              onClick={() =>
                this.props.handleTermsAndConditionsDownload(
                  this.termsAndConditions
                )
              }
            >
              {this.props.t("BusinessSettings.downloadTerms")}
            </span>
          </div>
        </div>

        <PendingActionPrompt
          {...this.props}
          disabled={false}
          customText={this.customText}
          showDeclineWarning={true}
          dealersActioned={this.state.dealersActioned}
          dealersNotActioned={this.state.dealersNotActioned}
          title={this.props.t("BusinessSettings.termsTitle")}
          buttonTitle={this.props.t("BusinessSettings.termsTitle")}
          onClose={this.handleDeclinePAClose}
          open={this.state.openDeclinePAPrompt}
          applyAll={() => this.applyAll(this.termsAndConditions, false)}
          applySome={() => this.applySelective(this.termsAndConditions, false)}
        />
        <PendingActionPrompt
          {...this.props}
          disabled={false}
          customText={this.customText}
          dealersActioned={this.state.dealersActioned}
          dealersNotActioned={this.state.dealersNotActioned}
          title={this.props.t("BusinessSettings.termsTitle")}
          buttonTitle={this.props.t("BusinessSettings.termsTitle")}
          onClose={this.handleConfirmPAClose}
          open={this.state.openConfirmPAPrompt}
          applyAll={() => this.applyAll(this.termsAndConditions, true)}
          applySome={() => this.applySelective(this.termsAndConditions, true)}
        />

        <ConfirmDialog
          {...this.props}
          dialogProps={this.deactivateDialogProps}
          showWarning={this.props.user.isLoggedInUserMDLR}
          dealerList={this.dealerList}
          open={this.state.openDeclineDialog}
          onConfirm={() =>
            this.handleConfirmation(
              this.termsAndConditions,
              false,
              this.props.user.getCommonIdsWithoutSDLR(),
              this.props.user.getDealerIdsWithoutSDLR()
            )
          }
          onCancel={this.handleDeclineClose}
          onClose={this.handleDeclineClose}
          attributes={this.tnCStatus}
          boldTitle={false}
        />
        <ConfirmDialog
          {...this.props}
          dialogProps={this.confirmDialogProps}
          showWarning={true}
          dealerList={this.dealerList}
          open={this.state.openConfirmDialog}
          onConfirm={() =>
            this.handleConfirmation(
              this.termsAndConditions,
              true,
              this.props.user.getCommonIdsWithoutSDLR(),
              this.props.user.getDealerIdsWithoutSDLR()
            )
          }
          onCancel={this.handleConfirmClose}
          onClose={this.handleConfirmClose}
          attributes={this.tnCStatus}
          boldTitle={false}
        />

        <HasPermissionTo
          perform={["acceptTermsAndConditions"]}
          permissions={this.props.user.permissions.rolePermissions}
          condition={this.getCondition()}
          render={() => (
            <>
              <div
                className={`${styles.acceptanceSelector} pagePaddingTop pagePaddingBottom primary-text-bold-color`}
              >
                {this.props.t("BusinessSettings.termsAccept")}
              </div>

              <Grid item md={12}>
                <div className={styles.dialogActions}>
                  <Button
                    onClick={() => this.openDialog(false)}
                    className="cancelledButton dialog"
                  >
                    {this.props.t("BusinessSettings.decline")}
                  </Button>
                  <Button
                    onClick={() => this.openDialog(true)}
                    className="confirmButton dialog"
                  >
                    {this.props.t("BusinessSettings.accept")}
                  </Button>
                </div>
              </Grid>
            </>
          )}
        />
      </div>
    );
  }
}

export default withTranslation("emp")(AcceptTermsAndConditions);
